import { TitleProps, Title } from "@mantine/core"

const CustomTitle = (props: TitleProps) => (
    <Title order={3} mt={'sm'} mb={'lg'} {...props}>{props.children}</Title>
  )

export default CustomTitle;